import gql from 'graphql-tag';

const NAME = 'sessionOutput';
const FRAGMENT = `
  fragment ${NAME} on CreatePublicSessionOutput {
    accessToken
    client
    email
    expiry
    firstName
    lastName
    phoneNumber
    source
    uid
  }
`;

export default {
  fragment: FRAGMENT,
  name: NAME,
  gql: gql`
    ${FRAGMENT}
  `,
};
